import { defineMessages } from 'react-intl';

/** The finished directed video (design directed-video k1 to k3). */
export const resultMessages = defineMessages({
  chip: { id: 'app.sml.musicVideo.directed.result.chip', defaultMessage: 'Directed video · beta' },
  title: { id: 'app.sml.musicVideo.directed.result.title', defaultMessage: 'Your video is ready' },
  story: {
    id: 'app.sml.musicVideo.directed.result.story',
    defaultMessage: '<b>“{story}”</b>, filmed as <b>{style}</b>. It is now the music video of {title}.',
  },
  storyPlain: {
    id: 'app.sml.musicVideo.directed.result.storyPlain',
    defaultMessage: 'It is now the music video of {title}.',
  },
  player: { id: 'app.sml.musicVideo.directed.result.player', defaultMessage: 'The music video of {title}' },
  notReady: {
    id: 'app.sml.musicVideo.directed.result.notReady',
    defaultMessage: 'The file is not ready. Open the video in the editor to render it again.',
  },
  clipsEyebrow: {
    id: 'app.sml.musicVideo.directed.result.clipsEyebrow',
    defaultMessage: 'The {count, plural, one {# new clip} other {# new clips}} of this video',
  },
  more: { id: 'app.sml.musicVideo.directed.result.more', defaultMessage: '+{count}' },
  factsLabel: { id: 'app.sml.musicVideo.directed.result.factsLabel', defaultMessage: 'About this video' },
  shots: { id: 'app.sml.musicVideo.directed.result.shots', defaultMessage: 'Shots' },
  shotsFrom: {
    id: 'app.sml.musicVideo.directed.result.shotsFrom',
    defaultMessage: 'from {count, plural, one {# new clip} other {# new clips}}',
  },
  effects: { id: 'app.sml.musicVideo.directed.result.effects', defaultMessage: 'Effects' },
  noEffects: { id: 'app.sml.musicVideo.directed.result.noEffects', defaultMessage: 'no effects' },
  length: { id: 'app.sml.musicVideo.directed.result.length', defaultMessage: 'Length' },
  lengthSub: { id: 'app.sml.musicVideo.directed.result.lengthSub', defaultMessage: 'the whole song' },
  lengthSubSize: {
    id: 'app.sml.musicVideo.directed.result.lengthSubSize',
    defaultMessage: 'the whole song · {height}p',
  },
  charged: { id: 'app.sml.musicVideo.directed.result.charged', defaultMessage: 'Charged' },
  creditsValue: {
    id: 'app.sml.musicVideo.directed.result.creditsValue',
    defaultMessage: '{count, plural, one {# credit} other {# credits}}',
  },
  chargedSubSeconds: {
    id: 'app.sml.musicVideo.directed.result.chargedSubSeconds',
    defaultMessage: '{count, plural, one {# clip} other {# clips}} · {seconds} s of new footage',
  },
  chargedBack: {
    id: 'app.sml.musicVideo.directed.result.chargedBack',
    defaultMessage: '{credits} back for {count, plural, one {# failed clip} other {# failed clips}}',
  },
  openInEditor: { id: 'app.sml.musicVideo.directed.result.openInEditor', defaultMessage: 'Open in the editor' },
  downloadShare: {
    id: 'app.sml.musicVideo.directed.result.downloadShare',
    defaultMessage: 'Download, share or post',
  },
  makeAnother: { id: 'app.sml.musicVideo.directed.result.makeAnother', defaultMessage: 'Make another video' },
  backToSong: { id: 'app.sml.musicVideo.directed.result.backToSong', defaultMessage: 'Back to the song' },
  footage: {
    id: 'app.sml.musicVideo.directed.result.footage',
    defaultMessage:
      'The {count, plural, one {# new clip is} other {# new clips are}} in Footage → Yours. Use them in any video of this workspace, free.',
  },
});
